import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Coils of electrical wire on a pallet: three torus coils of copper and
// insulated wire stacked and leaning, ready to be drawn off. A small stores
// prop.
const PALLET = "#6e4f2e";
const COPPER = "#b87333";
const RED = "#b5463a";
const BLACK = "#2a2a2e";

export const wireCoil = defineModel({
  id: "wire-coil",
  batchId: "electric",
  name: "Wire coil",
  tags: ["prop", "electric", "power", "cable", "wire", "yard"],
  summary: "Coils of wire on a small pallet.",
  footprint: 0.35,
  parts(): Part[] {
    return [
      // Pallet.
      { geometry: new THREE.BoxGeometry(0.7, 0.05, 0.5), color: PALLET, position: [0, 0.06, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.04, 0.06), color: "#5a4128", position: [0, 0.02, -0.2] },
      { geometry: new THREE.BoxGeometry(0.7, 0.04, 0.06), color: "#5a4128", position: [0, 0.02, 0.2] },
      // Two coils lying flat.
      { geometry: new THREE.TorusGeometry(0.13, 0.05, 8, 16), color: COPPER, position: [-0.16, 0.12, -0.08], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.12, 0.045, 8, 16), color: RED, position: [0.16, 0.11, 0.06], rotation: [Math.PI / 2, 0, 0] },
      // One coil standing on edge, leaning on the others.
      { geometry: new THREE.TorusGeometry(0.15, 0.05, 8, 18), color: BLACK, position: [0.0, 0.25, -0.12], rotation: [0.2, 0, 0] },
      // Loose lead trailing off the pallet.
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.3, 6), color: COPPER, position: [-0.34, 0.1, 0.08], rotation: [0, 0, 1.2] },
    ];
  },
  animations: [],
});
